/*************************************************
 * VirtuOwl
 * UserAction.js
 * Copyright © 2018 concertIDC. All rights reserved.
 *************************************************/
import store from '../../sessionStorage';
import _ from 'lodash';
import { ACTION_TYPES } from '../../utils/Constants';
import Client from '../../utils/ClientVOIM';
import URL from '../../utils/URL';
import { myLog } from '../../utils/Utility';
import { RESPONSE_CONSTANT } from '../../utils/ResponseConstant';
import localStore from '../../localStorage';
import Cookies from 'universal-cookie';
import { userSessionTimer, userTokenRenewalTimer } from '../../utils/AthuService';
import { Student, Tutor } from '../../utils/common/NamingTerms';

/**
 * Login
 * @param {Object} values
 * @param {Function} callBack
 */
export function login(values, callBack) {
    return function (dispatch) {
        Client.post(URL.LOGIN_NEW, values, false, 'student')
            .then((response) => {
                myLog('====logInUser response===::::', response);
                if (response.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                    if (
                        response.response.role === 'GRA_ADMIN' ||
                        response.response.role === RESPONSE_CONSTANT.LEVEL_ONE_ADMIN ||
                        response.response.role === RESPONSE_CONSTANT.BRANCHADMIN ||
                        response.response.role === RESPONSE_CONSTANT.LEVEL_TWO_ADMIN
                    ) {
                        store.set('insAdminSession', response.response);
                    } else if (
                        response.response.role === Student ||
                        response.response.role === Tutor
                    ) {
                        store.set('userSession', response.response);
                    }
                    const cookies = new Cookies();
                    cookies.set('AWSALBAPP-0', response.response.id, {
                        path: '/',
                        domain: '.virtuowlschools.com',
                    });

                    callBack(response);
                    dispatch({
                        type: ACTION_TYPES.LOGIN_USER,
                        payload: response.response,
                    });
                } else {
                    callBack(response);
                }
            })
            .catch((error) => {
                myLog('====logInUser error===????', error);
                callBack(false);
            });
    };
}

export function getUserInformation(callBack) {
    return function (dispatch) {
        myLog('====get user information ===::::');
        Client.get(URL.GET_USER_INFORMATION, null, true)
            .then((response) => {
                myLog('====get user information response===::::', response);
                if (response.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                    dispatch({
                        type: ACTION_TYPES.GET_USER_INFORMATION,
                        payload: response.response,
                    });
                }
                callBack(response);
            })
            .catch((error) => {
                myLog('====get user information error===????', error);
                callBack(false);
            });
    };
}

export const logout = (callback) => {
    var obj = {
        email: localStore.get('rememberMe') ? localStore.get('rememberMe').email : '',
    };
    store.clearAll();
    localStore.set('rememberMe', obj);
    clearInterval(userSessionTimer);
    clearInterval(userTokenRenewalTimer);
    callback();
    return { type: ACTION_TYPES.LOGOUT_USER, payload: null };
};

export function logOutUser(callBack) {
    myLog('logOut');
    return function (dispatch) {
        Client.put(URL.GRA_SINGOUT, null, true)
            .then((response) => {
                myLog('====logOut response===::::', response);
                callBack(response);
                dispatch({
                    type: ACTION_TYPES.LOGOUT_USER,
                    payload: null,
                });
            })
            .catch((error) => {
                myLog('====logOut error===????', error);
                callBack(false);
            });
    };
}

//forget password
export function forgetPassword(email, callBack) {
    let values = {
        email,
    };
    return function (dispatch) {
        myLog('====forgetPassword response===::::', values);
        Client.put(URL.FORGET_PASSWORD, values, false)
            .then((response) => {
                let result = {};
                if (typeof store.get('userSession') === 'object') {
                    result = store.get('userSession');
                }
                _.assign(result, response);
                myLog('====forgetPassword change response===::::', result);
                callBack(result);
                dispatch({
                    type: ACTION_TYPES.FORGET_PASSWORD,
                    payload: result,
                });
            })
            .catch((error) => {
                myLog('====forgetPassword error===????', error);
                callBack(false);
            });
    };
}

export function changePassword(values, callBack) {
    return function (dispatch) {
        Client.put(URL.CHNAGE_PASSWORD, values, true)
            .then((response) => {
                myLog('====changePassword response===::::', response);
                let result = {};
                if (typeof store.get('userSession') === 'object') {
                    result = store.get('userSession');
                }
                _.assign(result, response);
                myLog('====changePassword change response===::::', result);
                callBack(result);
                dispatch({
                    type: ACTION_TYPES.CHANGE_PASSWORD,
                    payload: result,
                });
            })
            .catch((error) => {
                myLog('====changePassword error===????', error);
                callBack(false);
            });
    };
}

// Get clever logged in user details
export function getCleverLoginUserDetails(params, callBack) {
    return function (dispatch) {
        Client.get(`${URL.GET_USER_INFORMATION}?isEnrollmentNeeded=true`, params, true)
            .then((response) => {
                myLog('====clever logInUser response===::::', response);
                if (response.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                    if (
                        response.response.role === 'GRA_ADMIN' ||
                        response.response.role === RESPONSE_CONSTANT.LEVEL_ONE_ADMIN ||
                        response.response.role === RESPONSE_CONSTANT.BRANCHADMIN ||
                        response.response.role === RESPONSE_CONSTANT.LEVEL_TWO_ADMIN
                    ) {
                        store.set('insAdminSession', response.response);
                    } else if (
                        response.response.role === Student ||
                        response.response.role === Tutor
                    ) {
                        store.set('userSession', response.response);
                    }
                    callBack(response);
                    dispatch({
                        type: ACTION_TYPES.LOGIN_USER,
                        payload: response.response,
                    });
                } else {
                    callBack(response);
                }
            })
            .catch((error) => {
                myLog('====clever logInUser error===????', error);
                callBack(false);
            });
    };
}

// Get clever level3 list details
export function getCleverLevel3List(callBack) {
    return function () {
        Client.get(URL.CLEVER_LEVEL3_LIST, null, true)
            .then((response) => {
                myLog('==== clever level3 list details response===::::', response);
                if (response.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                    callBack(response);
                }
            })
            .catch((error) => {
                myLog('====clever level3 list details===????', error);
                callBack(false);
            });
    };
}

// Add clever level3 details
export const addCleverLevel3Relation = (data, callBack) => {
    return function () {
        Client.post(URL.ADD_INSTITUTION_RELATION, data, true)
            .then((response) => {
                callBack(response);
            })
            .catch((error) => {
                myLog('====clever level3 details===????', error);
            });
    };
};

export function addUserContactInformation(values, callBack) {
    return function () {
        Client.put(URL.ADD_USER_CONTACT_INFORMATION, values, true)
            .then((response) => {
                myLog('====add user contact information response===::::', response);
                callBack(response);
            })
            .catch((error) => {
                myLog('====add user contact information response===????', error);
                callBack(false);
            });
    };
}

export const hideRemindMeLater = (data, callBack) => {
    return function () {
        Client.post(URL.HIDE_REMIND_ME_LATE, data, true)
            .then((response) => {
                callBack(response);
            })
            .catch((error) => {
                myLog('====clever level3 details===????', error);
            });
    };
};
